
import React from 'react';
import PortfolioItem from './PortfolioItem';
import { PortfolioItemData } from './portfolioData';

interface PortfolioListProps {
  items: PortfolioItemData[];
  isMobile: boolean;
  activeCategory: 'photos' | 'films';
}

const PortfolioList: React.FC<PortfolioListProps> = ({ items, isMobile, activeCategory }) => {
  return (
    <>
      {isMobile ? (
        <div className="grid grid-cols-1 gap-4 max-w-6xl mx-auto">
          {items.map((item, index) => (
            <div key={index} className="px-2">
              <PortfolioItem {...item} index={index} />
            </div>
          ))}
        </div>
      ) : (
        <div className="grid grid-cols-1 gap-6 max-w-6xl mx-auto">
          {items.map((item, index) => (
            <div key={index}>
              <PortfolioItem {...item} index={index} />
            </div>
          ))}
        </div>
      )}
    </>
  );
};

export default PortfolioList;
